import {Component, Input} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FieldsErrorsComponent} from "../fields-errors/fields-errors.component";
import {ControlContainer, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgClass, NgIf} from "@angular/common";
import { FieldDefinition } from 'src/app/model/field-definition';

export const FIELD_VIEW_PROVIDERS = [
  {
    provide: ControlContainer,
    useExisting: FormGroupDirective
  }
]

@Component({
  selector: 'ls-fields-base',
  standalone: true,
  imports: [
    FaIconComponent,
    FieldsErrorsComponent,
    FormsModule,
    NgIf,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './fields-base.component.html',
  styleUrl: './fields-base.component.scss'
})
export class FieldsBaseComponent<T> {
  @Input("question") question!: FieldDefinition<T>;
  @Input() form!: FormGroup;

  get isValid() {
    if(this.form.controls[this.question.key]) {
      return this.form.controls[this.question.key].valid || this.form.controls[this.question.key].pristine;
    }
    return false;
  }
}
